export default {
  SITE_ID_TO_RECREATE: 'site_id_to_recreate',
  SITE_ID_TO_SWITCH: 'site_id_to_switch',
  TEMPLATE_BUILD_SLUG: 'template_build_slug',
};
